import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import { configEnv } from '@/shared/config-env';
import { safeStringify } from '@/shared/helpers/safeStringify';
import { Router } from 'vue-router';

export const captureExceptionSentry = (error: any, place = 'Неизвестно') => {
  if (error instanceof Error) {
    const errorClone = new Error(error.message);
    let xmlReqId = '';
    // @ts-ignore
    if (error.config && error.config.headers) {
      // @ts-ignore
      xmlReqId = error.config.headers['X-Request-ID'];
    }
    // @ts-ignore
    errorClone.message += ' ,Причина: ' + place + ' ,url: ' + error?.request?.responseURL + (xmlReqId ? ' ,xmlReqId: ' + xmlReqId : '');
    Sentry.captureException(errorClone);
  } else {
    Sentry.captureMessage('Ошибка не типа Error ' + safeStringify(error) + ', Причина:' + place);
  }
};

export function sentryCaptureMessage(message: string) {
  Sentry.captureMessage(message);
}

/**
 * Интеграция с Sentry для логирования ошибок
 */
export const useSentry = (app: any, router: Router, kc: any) => {
  if (!configEnv.SENTRY_DSN || location.host.includes('localhost') || !kc) {
    return;
  }

  const { azp, email } = kc.tokenParsed;

  Sentry.init({
    app,
    release: `lk-client@${configEnv.PACKAGE_VERSION}`,
    // @ts-ignore
    dsn: configEnv.SENTRY_DSN,
    integrations: [
      new BrowserTracing({
        tracePropagationTargets: [],
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      }),
    ],
    initialScope: {
      user: { azp, email },
    },
    tracesSampleRate: 1.0,
  });
};
